module.exports = __webpack_public_path__ + "static/interview_3-b50bd03de6c159d4e317ea83edcc0a0c.m4a";